// formázza a balesetnél a díjakat
export default function formatCurrency(num) {
    return `${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} Ft`;
}
